<template>
  <form
    @submit.prevent="submit"
  >
    <div class="mb-3">
      <input
        v-model="form.name"
        type="text"
        placeholder="Nome completo"
        required
        @blur="$v.form.name.$touch()"
        :class="classValidation('name')"
        ref="name"
      />
    </div>

    <div class="mb-3">
      <input
        v-model="form.email"
        type="email"
        placeholder="E-mail"
        required
        @blur="$v.form.email.$touch()"
        :class="classValidation('email')"
        ref="inputEmail"
      />
    </div>

    <div class="mb-3">
      <input
        v-model="form.password"
        type="password"
        placeholder="Senha"
        required
        @blur="$v.form.password.$touch()"
        :class="classValidation('password')"
      />
    </div>

    <div class="mb-3">
      <input
        v-model="form.password_confirmation"
        type="password"
        name="password_confirmation"
        placeholder="Repita a Senha"
        required
        @blur="$v.form.password_confirmation.$touch()"
        :class="classValidation('password_confirmation')"
      />
    </div>

    <PrimaryButton
      type="submit"
      :full="true"
      :disabled="$v.form.$invalid"
    >CADASTRAR</PrimaryButton>

    <p class="disclaimer">
      Se cadastrando, você estará concordando com a <router-link :to="{name: 'legal.privacy'}" target="_blank">Política de Privacidade</router-link> e <router-link :to="{name: 'legal.terms'}" target="_blank">Termos de Uso</router-link>.
    </p>
  </form>
</template>

<script>
  import { mapMutations } from 'vuex'
  import PrimaryButton from '@/components/buttons/PrimaryButton'
  import authSignUpRules from '@/validations/auth/authSignUpRules'
  import classValidationChecker from '@/utils/classValidationChecker'

  export default {
    data: () => ({
      form: {
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
      }
    }),

    validations: {form: authSignUpRules},

    components: {
      PrimaryButton,
    },

    mounted () {
      this.$nextTick(() => this.$refs.name.focus())
    },

    methods: {
      ...mapMutations('auth', ['setLoading']),

      async submit () {
        try {
          this.setLoading(true)

          await this.$store.dispatch('auth/register', this.form)
        } catch (err) {
          this.setLoading(false)
          this._handleError(err)
        }
      },

      _handleError (response) {
        this.$store.commit('auth/setError', response.data.errors.join(', '))
        this.form.email = this.form.password = this.form.password_confirmation = ''
        this.$refs.inputEmail.focus()
      },

      classValidation (field) {
        return classValidationChecker(this.$v.form[field])
      }
    }
  }
</script>

<style scoped lang="scss">
  .disclaimer {
    margin-top: 1.875rem;
    font-size: 13px;
  }
</style>